export default __webpack_public_path__ + "static/media/NR-CW530HVK3.58003e9d.jpg";